<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-05 15:26:09
 * @Description: 账号安全 账号设置 别名
-->
<template>
	<div>
		<Head :title="$t('home.account_set.alias')" />
		<a-form-model :model="form" :rules="rules" ref="form" class="flexForm">
			<a-form-model-item label="" prop="alias" :wrapper-col="{ span: 16, offset: 4 }">
				<a-input v-model="form.alias" :placeholder="$t('home.account_set.alias_placeholder')" />
				<a-tooltip :title="$t('home.account_set.alias_tooltip')">
					<a-icon type="question-circle" />
				</a-tooltip>
			</a-form-model-item>
		</a-form-model>
	</div>
</template>

<script>
import Head from "./components/Head";
export default {
	components: { Head },
	props: {
		selfAlias: { type: String, default: "" },
	},
	data() {
		let validateAlias = (rule, value, callback) => {
			if (value != "") {
				let reg = new RegExp(/[^\d|a-z|A-Z|,@.]/);
				if (reg.test(value)) {
					callback(new Error(this.$t("home.account_set.alias_error")));
				}
				callback();
			}
		};
		return {
			form: { alias: "" },
			rules: {
				alias: [{ required: true, message: this.$t("home.account_set.alias_placeholder") }, { validator: validateAlias }],
			},
		};
	},
	created() {
		this.form.alias = this.selfAlias;
	},
};
</script>

<style lang="less" scoped>
.flexForm::v-deep {
	.ant-form-item-children {
		display: flex;
		align-items: center;
		.anticon {
			cursor: pointer;
			margin-left: 8px;
		}
	}
}
</style>
